import {Component} from '@angular/core';
import {NavController, ViewController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from '../../../app/util';
import {CONFIG} from '../../../app/config';

import {SpotdayService} from '../../../providers/spotday-service';
import {DataService} from '../../../providers/data-service';

import {LogadoService} from "../../../providers/logado-service";
import {CLOSE_PAGE} from "../../../app/import";
import {NavRepository} from "../../../repositories/nav-repository";

@Component({
    selector: 'page-profile-born',
    templateUrl: 'profile-born.html',
    providers: [SpotdayService]
})
export class ProfileBornPage {

    config: any;
    logado: any;
    perfil: any;

    etapa: number = 0;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public dataService: DataService, public util: Util,
                public navRepository: NavRepository,
                public spotdayService: SpotdayService, public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;


        //Etapa - 1: Escolher Lugares | 2: Criar Aniversário
        //Quando vem do site, deve ja mandar 2 e HotspotID = myKit
        this.etapa = this.navParams.get('etapa') ? this.navParams.get('etapa') : this.etapa;


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Birthday', '/profile-born');
    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    convidados() {


    }

    dismiss() {

        let alerta = 'Você cancelará sua lista de aniversário.';
        this.util.alertQuestion('Deseja sair?', alerta, 'Sair', () => {

            this.util.statusBarColor(TStatusBar.sbStyleDefault);

            if (!this.viewCtrl.isOverlay) this.navCtrl.pop();
            else this.navRepository.closePage(this.navCtrl, CLOSE_PAGE).subscribe();


        });

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-born/profile-born.ts